import React, { useEffect, useRef } from "react";

/**
 * Liste des images des marques (dans public/images).
 * Les noms de fichiers contiennent des espaces, on utilise encodeURI pour les URLs.
 */
const BRAND_IMAGES = [
  "Group 1000004853.png",
  "Group 1000004854.png",
  "Group 1000004855.png",
  "Group 1000004856.png",
  "Group 1000004857.png",
  "Group 1000004858.png",
  "Group 1000004859.png",
  "Group 1000004860.png",
  "Group 1000004861.png",
  "Group 1000004862.png",
  "Group 1000004863.png",
  "Group 1000004864.png",
  "Group 1000004865.png",
  "Group 1000004866.png",
  "image 78.png",
];

/** Pause après un scroll manuel (ms) avant de reprendre l’auto-scroll */
const PAUSE_AFTER_MANUAL_MS = 2500;

function NosMarques() {
  const baseUrl = `${process.env.PUBLIC_URL || ""}/images`;
  const scrollRef = useRef<HTMLDivElement>(null);
  const pausedRef = useRef(false);
  const pauseTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const halfWidthRef = useRef(0);

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;

    const onInteraction = () => {
      pausedRef.current = true;
      if (pauseTimeoutRef.current) clearTimeout(pauseTimeoutRef.current);
      pauseTimeoutRef.current = setTimeout(() => {
        pausedRef.current = false;
        pauseTimeoutRef.current = null;
      }, PAUSE_AFTER_MANUAL_MS);
    };

    el.addEventListener("wheel", onInteraction, { passive: true });
    el.addEventListener("touchstart", onInteraction, { passive: true });
    return () => {
      el.removeEventListener("wheel", onInteraction);
      el.removeEventListener("touchstart", onInteraction);
      if (pauseTimeoutRef.current) clearTimeout(pauseTimeoutRef.current);
    };
  }, []);

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;

    const ro = new ResizeObserver(() => {
      if (scrollRef.current) {
        halfWidthRef.current = scrollRef.current.scrollWidth / 2;
      }
    });
    ro.observe(el);
    halfWidthRef.current = el.scrollWidth / 2;

    const intervalId = setInterval(() => {
      const scrollEl = scrollRef.current;
      if (!scrollEl) return;
      if (halfWidthRef.current <= 0 && scrollEl.scrollWidth > 0) {
        halfWidthRef.current = scrollEl.scrollWidth / 2;
      }
      if (pausedRef.current) return;
      scrollEl.scrollLeft += 1;
      const half = halfWidthRef.current;
      if (half > 0 && scrollEl.scrollLeft >= half) {
        scrollEl.scrollLeft = 0;
      }
    }, 40);

    return () => {
      clearInterval(intervalId);
      ro.disconnect();
    };
  }, []);

  const logosList = [...BRAND_IMAGES, ...BRAND_IMAGES];

  return (
    <section className="nos-marques-section">
      <div className="container-easy-market">
        <div className="nos-marques-header">
          <h3 className="nos-marques-title title-home-page-theme text-center">
            Nos marques
          </h3>
        </div>
        <div className="nos-marques-scroll-wrapper">
          <div className="nos-marques-scroll" ref={scrollRef}>
            {logosList.map((filename, index) => (
              <div key={`${filename}-${index}`} className="nos-marques-card">
                <img
                  src={`${baseUrl}/${encodeURIComponent(filename)}`}
                  alt=""
                  className="nos-marques-logo"
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default NosMarques;
